import React from "react";
import SidebarSubmenu from "../Sidebar/SidebarSubmenu";
import NavSubItem from "../Sidebar/NavSubItem";
import IconLiveImage from "../../Icons/TopCommandPanel/LiveImage";
import IconEfi from "../../Icons/TopCommandPanel/Efi";
import IconFocusGraph from "../../Icons/TopCommandPanel/FocusGraph";
import IconLastCapturedImage from "../../Icons/TopCommandPanel/LastCapturedImage";
import IconDropLocation from "../../Icons/TopCommandPanel/DropLocation";

type Props = {
  imagerIdentifier?: string;
}

const ImagerNavSubMenu = ({imagerIdentifier = ""}: Props) => {

  return (
    <SidebarSubmenu>
      <NavSubItem 
        label={"Live Image"}
        key="live_image"
        to={`/imager/live-image/${imagerIdentifier}`}
        icon={<IconLiveImage />}
      />
      <NavSubItem 
        label={"EFI"}
        key="efi"
        to={`/imager/efi/${imagerIdentifier}`}
        icon={<IconEfi />}
      />
      <NavSubItem 
        label={"Drop Location"}
        key="drop_location"
        to={`/imager/drop-location/${imagerIdentifier}`}
        icon={<IconDropLocation />}
      />
      <NavSubItem 
        label={"Focus Graph"}
        key="focus"
        to={`/imager/focus/${imagerIdentifier}`}
        icon={<IconFocusGraph />}
      />
      <NavSubItem 
        label={"Last Captured"}
        key="last_captured"
        to={`/imager/last-captured/${imagerIdentifier}`}
        icon={<IconLastCapturedImage />}
      />
    </SidebarSubmenu>
  )
}

export default ImagerNavSubMenu;